import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getReservation } from "../../../services/OtherService";
import { RequisitionStatusBadge } from "../Requisition";
const ReservationDetails = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const { user_permission, role } = useSelector((state) => state.auth.user);
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchRequisition(id);
    return () => {
      setReservation(null);
      setLoading(false);
      setError(null);
    };
  }, [id]);

  const fetchRequisition = async (id) => {
    setLoading(true);
    try {
      const response = await getReservation(id);
      setReservation(response.data.data);
    } catch (err) {
      setError(
        err?.response?.data?.message || "Error fetching reservation details"
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card card-body">
              <div className="text-center fw-bold">Loading...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card card-body">
              <div className="alert alert-danger">{error}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm rounded-circle"
                  style={{ padding: "5px 9px" }}
                  onClick={() => navigate("/reservation")}
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <h4 className="mb-0 ms-2">Reservation Details</h4>
              </div>
              {(role === "Admin" || user_permission.manage_material) && (
                <button
                  type="button"
                  onClick={() => {}}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa-solid fa-pen-to-square me-1" />
                  <span>Edit </span>
                </button>
              )}
            </div>
            <div className="card-body p-0">
              {reservation && (
                <div>
                  <div className="row p-3">
                    <div className="col-md-4">
                      <h5>Reference No: {reservation.reference_no}</h5>
                      <p>Reservation Type: {reservation.reservation_type}</p>
                      <p>
                        Status:{" "}
                        <RequisitionStatusBadge status={reservation.status} />
                      </p>
                    </div>
                    <div className="col-md-4">
                      <p>
                        Reserved By: {reservation.reserved_by?.name || "N/A"}
                        <p>Reserved At: {reservation.created_at}</p>
                      </p>
                    </div>
                    <div className="col-md-4">
                      <h5>Total Materials: {reservation.total_material}</h5>
                      <h5>Total Quantites: {reservation.total_quantity}</h5>
                    </div>
                  </div>

                  <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                    <table
                      id="empoloyees-tblwrapper"
                      className="table ItemsCheckboxSec dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Material</th>
                          <th>Source</th>
                          <th>Reserved Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reservation.items.map((item) => (
                          <tr key={item.id}>
                            <td>{item.product_name}</td>
                            <td>{item.source_name}</td>
                            <td>{item.quantity || "N/A"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                      <p className="px-3">
                        Total Material: {reservation.items.length}
                      </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationDetails;
